import { IEvent } from "../../../../models/Event"

export const Terms: React.FC<{ event: IEvent }> = ({ event }) => {
    return (
        <div className="terms-container">
            <h2 className="panel-title">תקנון</h2>
            {event.terms && <p className="panel-text">
                {event.terms}
            </p>}
            <div className="panel-actions">
                {event.termLinks && event.termLinks.map(link =>
                    <a className="btn btn-outline" href={link.link} key={link.link} target="_blank" rel="noreferrer">{link.name}</a>
                )}
            </div>
        </div>
    )
}
